import { render, staticRenderFns } from "./HowToJoin.vue?vue&type=template&id=3a0d380e&scoped=true"
import script from "./HowToJoin.vue?vue&type=script&lang=js"
export * from "./HowToJoin.vue?vue&type=script&lang=js"
import style0 from "./HowToJoin.vue?vue&type=style&index=0&id=3a0d380e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0d380e",
  null
  
)

export default component.exports